<template>
  <!--  begin intro section -->
  <section class="intro bg-light-gray">
    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <img
            src="assets/img/intro.jpg"
            class="img-responsive center-block"
            alt="intro"
          />
        </div>

        <div class="col-md-7">
          <div class="intro-description">
            <h2>Transformamos ideias em soluções digitais</h2>
            <p>
              Na DIGIPROD, unimos tecnologia de ponta e criatividade para
              entregar soluções sob medida em desenvolvimento, infraestrutura e
              marketing digital. Nossa missão é tornar a tecnologia acessível,
              escalável e alinhada às necessidades reais de negócios.
            </p>

            <ul class="points">
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Desenvolvimento personalizado com foco em performance e
                escalabilidade.
              </li>
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Infraestrutura moderna em cloud com automações e segurança.
              </li>
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Design, branding e marketing digital para posicionar sua marca.
              </li>
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Atendimento próximo, ágil e centrado no sucesso do cliente.
              </li>
            </ul>
            <!-- end of /.points -->

            <!-- <a href="#" class="btn btn-slategray"> purchase </a> -->
            <!-- /purchase button -->
          </div>
          <!-- end of /.intro-description -->
        </div>
      </div>
    </div>
    <!-- end of /.container -->
  </section>
  <!--  end of intro section -->
</template>

<script>
export default {
  name: "IntroSection",
};
</script>
